'use client';
// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/refs */
import HeaderButtons from '@components/shared/Header/components/HeaderButtons';
import { ContentType } from '@lib/sanity/queries/modules/content/types';
import { TextVariant } from '@ui/Text/constants';
import PortableText from '@ui/Text/PortableText';
import Text from '@ui/Text/Text';
import cn from '@utils/cn';
import { AnimatePresence, MotionDiv } from '@lib/motion';
import { useRef } from 'react';

type Props = {
  isSelected: boolean;
  item: NonNullable<ContentType['contentList']>[number];
  onClick: (index: number) => void;
  index: number;
  icons: Record<string, React.ReactNode>;
  showAnimation?: boolean | null;
  animationDuration?: number | null;
  isInitialSlide?: boolean;
};
export default function AccordionItem({
  isSelected,
  item,
  onClick,
  icons,
  index,
  showAnimation,
  animationDuration,
  isInitialSlide,
}: Props) {
  const itemRef = useRef<HTMLDivElement>(null);
  const showDescription = item.description && isSelected;
  const hasIcon =
    item.icon?.icon?.result ||
    item.icon?.default?.image?.image?.asset?.url ||
    item.icon?.default?.video?.video?.playbackId;
  return (
    <div
      className={cn('flex flex-col justify-start  pt-6', {
        'pb-6': !showDescription,
      })}
    >
      <span
        className={cn('group flex w-full cursor-pointer items-center justify-start gap-4', {
          'is-active': isSelected,
          'pb-2': showDescription,
        })}
        onClick={() => onClick(index)}
      >
        {hasIcon && item.icon?._id && icons[item.icon._id]}
        <Text
          content={item.title?.value}
          variant={TextVariant.SubtitleLG}
          className={cn({
            'group-hover:underline group-hover:underline-offset-4': !isSelected,
          })}
        />
      </span>
      <AnimatePresence>
        <MotionDiv
          className={cn('overflow-hidden', { 'pl-10': hasIcon })}
          initial={{
            height: showDescription ? itemRef.current?.offsetHeight : 0,
          }}
          animate={{
            height: showDescription ? itemRef.current?.offsetHeight : 0,
            transition: { duration: 0.5 },
          }}
        >
          <MotionDiv
            initial={{ opacity: isInitialSlide ? 1 : 0 }}
            animate={{
              opacity: showDescription ? 1 : 0,
              transition: { duration: 0.5, delay: 0.1 },
            }}
            exit={{ opacity: 0, transition: { duration: 0.5 } }}
            ref={itemRef}
            className="flex flex-col gap-4 overflow-hidden pb-4"
          >
            <PortableText content={item.description} variant={TextVariant.TextBodyMD} />

            <HeaderButtons className="flex" buttonLink={item.buttonLink} />
          </MotionDiv>
        </MotionDiv>
      </AnimatePresence>
      <div className={cn({ 'ml-10': hasIcon })}>
        {showDescription ? (
          showAnimation ? (
            <MotionDiv
              initial={{ width: 0 }}
              animate={{
                width: '100%',
                transition: { duration: animationDuration },
              }}
              className="bg-secondary h-[1.5px]"
            />
          ) : (
            <div className="bg-secondary h-[1.5px] w-full" />
          )
        ) : null}
      </div>
    </div>
  );
}
